import API from "../../../store/api";
import { authLogout } from "../../../store/actions/authActions";
import { setGroups, clearGroups } from "../../../store/actions/groupsActions";
import { setMessage } from '../../../store/actions/dialogActions';

export const getAllGroups = (bearerAuth) => {
  return async dispatch => {
    API.get("/api/portal/groups")
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status < 500) // anything under 500 handled in code, 500+ thrown as exception
      .then((response) => {
        if (response.status === 200) {
          dispatch(setGroups(response.body))
        } else if (response.status === 401) {
          dispatch(clearGroups);
          dispatch(authLogout);
        } else {
          dispatch(clearGroups);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'Group Retrieval Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(clearGroups);
      })
  }
}